import { Montserrat } from "next/font/google";

const mont = Montserrat({
  subsets: ["latin"],
});

export const montserrat = mont.className;
